import { types } from 'mobx-state-tree';
import { TitlesEnum } from '../../../common/v1/definitions/Titles';

import { Address, EmailAddress } from '../definitions/common';
import NationalBankAuthorizedUser from './NationalBankAuthorizedUser';


const HostedApplication = types
    .model('HostedApplication', {
        // Plastk specific
        embossedName: types.maybe(types.string),
        cardReason: types.maybe(types.string),
        usedEmails: types.optional(types.array(EmailAddress), []),

        // National bank specific
        title: types.maybe(TitlesEnum),
        phoneType: types.maybe(types.string),
        propertyStatus: types.maybe(types.string),
        currentAddressDuration: types.maybe(types.string),
        previousAddress: types.maybe(Address),
        previousAddressDuration: types.maybe(types.string),
        previousPropertyStatus: types.maybe(types.string),
        householdIncomeBracket: types.maybe(types.string),
        investableAssetsBracket: types.maybe(types.string),
        insurancePlan: types.maybe(types.string),
        authorizedUser: types.maybe(NationalBankAuthorizedUser),

        // Shared hosted app fields
        card: types.maybe(types.string),
        cardName: types.maybe(types.string),
        isSubmitting: types.maybe(types.boolean),
        applicationId: types.maybeNull(types.string),
        redirectUrl: types.maybeNull(types.string),
        responseStatus: types.maybe(types.integer),
        responseMessage: types.maybe(types.string),
    });

export default HostedApplication;
